/* global lightbox */
/* eslint-env jquery */

'use strict';

jQuery( function( $ ) {

	// Show login form
	$( document ).on( 'click', '#showLoginForm', function( event ) {
		event.preventDefault();

		if ( ! $( '#loginFormContent' ).hasClass( 'login--visible' ) ) {
			$( '#loginFormContent' ).slideDown().addClass( 'login--visible' );
		} else {
			$( '#loginFormContent' ).slideUp().removeClass( 'login--visible' );
		}

	} );

	// Hide login form
	$( document ).on( 'click', '#hideLoginForm', function( event ) {
		event.preventDefault();

		if ( $( '#loginFormContent' ).hasClass( 'login--visible' ) ) {
			$( '#loginFormContent' ).slideUp().removeClass( 'login--visible' );
		}

	} );

	// Show Cart Overview
	$( document ).on( 'click', '#showOverview, #showOverviewMobile', function( event ) {
		event.preventDefault();

		if ( $( '#loginFormContent' ).hasClass( 'login--visible' ) ) {
			$( '#loginFormContent' ).slideUp().removeClass( 'login--visible' );
		}

		if ( ! $( '#overviewContent' ).hasClass( 'overview--visible' ) ) {
			$( '#overviewContent' ).addClass( 'overview--visible' );
		}

		$( 'body' ).css( { 'position': 'sticky', 'overflow': 'hidden' } );
	} );

	// Hide Cart Overview
	$( document ).on( 'click', '#hideOverview', function( event ) {
		event.preventDefault();

		if ( $( '#overviewContent' ).hasClass( 'overview--visible' ) ) {
			$( '#overviewContent' ).removeClass( 'overview--visible' );
		}

		$( 'body' ).css( { 'position': 'static', 'overflow': 'auto' } );
	} );

	// Show Categories
	$( document ).on( 'click', '#showCategories', function( event ) {
		event.preventDefault();

		if ( ! $( '#categoriesContent' ).hasClass( 'sidebar-shop--visible' ) ) {
			$( '#categoriesContent' ).addClass( 'sidebar-shop--visible' );
		}

		$( 'body' ).css( { 'position': 'sticky', 'overflow': 'hidden' } );
	} );

	// Hide Categories
	$( document ).on( 'click', '#hideCategories', function( event ) {
		event.preventDefault();

		if ( $( '#categoriesContent' ).hasClass( 'sidebar-shop--visible' ) ) {
			$( '#categoriesContent' ).removeClass( 'sidebar-shop--visible' );
		}

		$( 'body' ).css( { 'position': 'static', 'overflow': 'auto' } );

	} );

	// Show Mobile Menu
	$( document ).on( 'click', '#showMobileMenu', function( event ) {
		event.preventDefault();

		if ( ! $( '#mobileMenu' ).hasClass( 'nav-mobile--visible' ) ) {
			$( '#mobileMenu' ).addClass( 'nav-mobile--visible' );
		}

		$( 'body' ).css( { 'position': 'sticky', 'overflow': 'hidden' } );
	} );

	// Hide Mobile Menu
	$( document ).on( 'click', '#hideMobileMenu', function( event ) {
		event.preventDefault();

		if ( $( '#mobileMenu' ).hasClass( 'nav-mobile--visible' ) ) {
			$( '#mobileMenu' ).removeClass( 'nav-mobile--visible' );
		}

		$( 'body' ).css( { 'position': 'static', 'overflow': 'auto' } );

	} );

	// Hide Mini Cart
	$( document ).on( 'click', '.btn-remove', function( event ) {
		event.preventDefault();

		$( this ).parent().parent().parent().fadeOut();

	} );


	$( '.slider--primary' ).slick( {
		infinite: true,
		speed: 1200,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
				  arrows: false,
				  dots: true,
				}
			},
			{
			  breakpoint: 576,
			  settings: {
				arrows: false,
				dots: true,
			  }
			}
		  ]
	} );

	$( '.slider--featured' ).slick( {
		arrows: true,
		infinite: true,
		speed: 1200,
		slidesToShow: 5,
		autoplay: false,
		autoplaySpeed: 6000,
		pauseOnHover: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
				  slidesToShow: 4,
				  arrows: false,
				  dots: true,

				}
			},
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 2,
				arrows: false,
				dots: true,
			  }
			}
		  ]
	} );

	$( '.slider--partners' ).slick( {
		arrows: false,
		infinite: true,
		speed: 1200,
		slidesToShow: 8,
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
				  slidesToShow: 4,

				}
			},
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 3,
			  }
			}
		  ]
	} );

	$( document ).on( 'click', '.nav-mobile__link--toggler', function( event ) {
		event.preventDefault();

	    const element = $( this );

	    if ( element.hasClass( 'nav-mobile__link--visible' ) ) {
	        element.removeClass( 'nav-mobile__link--visible' );
	        element.next().slideUp( 350 );
	    } else {
			if ( $( '.nav-mobile__link--visible' ).length ) {
				$( '.nav-mobile__link--visible' ).next().slideUp( '350' );
				$( '.nav-mobile__link--visible' ).removeClass( 'nav-mobile__link--visible' );
			}
			element.addClass( 'nav-mobile__link--visible' );
			element.next().slideToggle( 350 );
		}
	} );

	$( document ).on( 'click', '.nav-categories__link--toggler', function( event ) {
		event.preventDefault();

	    const element = $( this );

	    if ( element.hasClass( 'nav-categories__link--visible' ) ) {
	        element.removeClass( 'nav-categories__link--visible' );
	        element.next().slideUp( 350 );
	    } else {
			if ( $( '.nav-categories__link--visible' ).length ) {
				$( '.nav-categories__link--visible' ).next().slideUp( '350' );
				$( '.nav-categories__link--visible' ).removeClass( 'nav-categories__link--visible' );
			}
			element.addClass( 'nav-categories__link--visible' );
			element.next().slideToggle( 350 );
		}
	} );

	$( document ).on( 'click', '.nav-thumbnails__link', function( event ) {
		event.preventDefault();
		const target = $( this ).attr( 'href' );

		$( '.product-images__item' ).removeClass( 'product-images__item--visible' );
		$( target ).addClass( 'product-images__item--visible' );
	} );


	lightbox.option( {
		disableScrolling: true,
		showImageNumberLabel: false,
	} );

	$( document ).on( 'click', '#decQty', function() {
		const val = parseInt( $( '#quantity' ).val() );
		const min = parseInt( $( '#quantity' ).attr( 'min' ) );
		if ( val > min ) {
			$( '#quantity' ).val( ( val - 1 ) );
		}
	} );

	$( document ).on( 'click', '#incQty', function() {
		const val = parseInt( $( '#quantity' ).val() );
		const max = parseInt( $( '#quantity' ).attr( 'max' ) );
		if ( val < max ) {
			$( '#quantity' ).val( ( val + 1 ) );
		}
	} );

	$( document ).on( 'click', '.nav-tabs__link', function( event ) {
		event.preventDefault();
		const target = $( this ).attr( 'href' );

		$( '.nav-tabs__link' ).removeClass( 'nav-tabs__link--active' );
		$( this ).addClass( 'nav-tabs__link--active' );
		$( '.product-tabs__tab' ).hide();
		$( target ).fadeIn();
	} );

	const mobileOnly = window.matchMedia( '(max-width: 768px)' );

	if ( mobileOnly.matches ) {
		$( document ).on( 'click', '.site-footer__widget-title', function( event ) {
			event.preventDefault();
			$( this ).toggleClass( 'site-footer__widget-title--open' );
			$( this ).siblings( '.site-footer__widget-content' ).slideToggle().toggleClass( 'site-footer__widget-content--visible' );
		} );
	}

} );
